import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableActions from "./table-actions";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { NoData } from "src/shared/components/tables/no-data";
import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

const TermsTable = ({
  termsList,
  isLoading,
  refetch,
}: {
  termsList: any;
  isLoading: boolean;
  refetch: Function;
}) => {
  const emptyDataArr = termsList?.length === 0;
  const { t } = useTranslation("addSales");
  const { t: generalT } = useTranslation("general");
  const tableHeadText = [t("title"), t("isMandatory"), generalT("actions")];

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {tableHeadText.map((item) => (
              <TableCell
                key={item}
                align="center"
                sx={{
                  fontSize: "12px",
                  fontWeight: 600,
                  lineHeight: "18px",
                  color: "#475467",
                  bgcolor: "#F9FAFB",
                }}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        {isLoading ? (
          <TableLoadingSkeleton rowsLength={8} cellsLength={6} />
        ) : (
          <TableBody>
            {termsList?.map((row: any) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{row.title}</TableCell>
                <TableCell align="center">
                  <Chip
                    size="small"
                    color={row.is_mandatory ? "success" : "error"}
                    label={row.is_mandatory ? generalT("yes") : generalT("no")}
                  />
                </TableCell>
                <TableCell align="center">
                  <TableActions
                    refetch={refetch}
                    termData={row}
                    type={row.type}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
      {emptyDataArr && <NoData />}
    </TableContainer>
  );
};
export default TermsTable;
